import { Row, Col, Input, Select, Button } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { useMemo, useState } from "react";
const { Option } = Select;

const filterOption = (input, option) =>
  (option?.children ?? "").toString().toLowerCase().includes(input.toLowerCase());

export default function EntregasPOFilters({ proyectos = [], departamentos = [], municipios = [], onFilter }) {

  const [filters, setFilters] = useState({
    search: "",
    oid_proyecto: null,
    oid_departamento: null,
    oid_municipio: null,
    tipo_entrega: null
  });

  const municipiosFiltrados = useMemo(() => {
    if (!filters.oid_departamento) return municipios;
    return municipios.filter((m) => Number(m.oid_depto) === Number(filters.oid_departamento));
  }, [municipios, filters.oid_departamento]);

  const emit = (next) => {
    setFilters(next);
    onFilter?.({
      search: next.search,
      oid_proyecto: next.oid_proyecto,
      oid_municipio: next.oid_municipio,
      tipo_entrega: next.tipo_entrega
    });
  };

  const handleChange = (key, value) => {
    const next = { ...filters, [key]: value };
    if (key === "oid_departamento") next.oid_municipio = null;
    emit(next);
  };

  const limpiar = () => {
    emit({ search: "", oid_proyecto: null, oid_departamento: null, oid_municipio: null, tipo_entrega: null });
  };

  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 20 }}>
      <Col xs={24} md={6}>
        <Input.Search
          allowClear
          placeholder="Buscar beneficiario, identificación o producto"
          prefix={<SearchOutlined />}
          onSearch={(v) => handleChange("search", v)}
        />
      </Col>
      <Col xs={12} md={4}>
        <Select allowClear placeholder="Proyecto" style={{ width: "100%" }} showSearch filterOption={filterOption}
          value={filters.oid_proyecto} onChange={(v) => handleChange("oid_proyecto", v)}>
          {proyectos.map((p) => <Option key={p.oid} value={p.oid}>{p.codigo} - {p.proyecto}</Option>)}
        </Select>
      </Col>
      <Col xs={12} md={4}>
        <Select allowClear placeholder="Departamento" style={{ width: "100%" }} showSearch filterOption={filterOption}
          value={filters.oid_departamento} onChange={(v) => handleChange("oid_departamento", v)}>
          {departamentos.map((d) => <Option key={d.oid} value={d.oid}>{d.departamento}</Option>)}
        </Select>
      </Col>
      <Col xs={12} md={4}>
        <Select allowClear placeholder="Municipio" style={{ width: "100%" }} showSearch filterOption={filterOption}
          value={filters.oid_municipio} onChange={(v) => handleChange("oid_municipio", v)}>
          {municipiosFiltrados.map((m) => <Option key={m.oid} value={m.oid}>{m.municipio}</Option>)}
        </Select>
      </Col>
      <Col xs={12} md={5}>
        <Select allowClear placeholder="Tipo" style={{ width: "100%" }}
          value={filters.tipo_entrega} onChange={(v) => handleChange("tipo_entrega", v)}>
          <Option value={1}>Participante</Option>
          <Option value={2}>Organización</Option>
        </Select>
      </Col>
      <Col xs={12} md={1}>
        <Button icon={<ClearOutlined />} onClick={limpiar} />
      </Col>
    </Row>
  );
}
